import PatientTaskActivityDrawer from "../../../modules/patient/components/PatientTaskActivityDrawer";
import { usePatientTaskHistory } from "../../hooks/usePatientTaskHistory";
import { useReactBridgeDispatchEvent } from "../../hooks/useReactBridgeEvent";

export default function PatientTaskActivityListener() {
  const { state, open, close } = usePatientTaskHistory();

  useReactBridgeDispatchEvent({
    eventName: "PATIENT:OPEN_TASK_ACTIVITY",
    onEvent: ({ patientId }) => open(patientId),
  });

  return <PatientTaskActivityDrawer patientId={state?.patientId ?? null} onClose={close} />;
}
